// extracted by mini-css-extract-plugin
module.exports = {"overlay":"MediaContentCard_overlay__2uhgu","icon":"MediaContentCard_icon__3o4Mv","span":"MediaContentCard_span__AphFK"};